import Image from '@ui/image'
import { Container, Row, Col } from '@ui/wrapper'
import {
  BoxImgWrapper,
  BoxImgInner,
  BoxImgMedia,
  BoxImgContent,
  BoxImgText,
  Break,
  HeadingWrap,
  TextWrap
} from './style'

const BoxImage = ({
  children,
  images,
  name,
  title,
  desc,
  className,
  showTitle = true,
  leftCol = 3,
  rightCol = 9,
  ...restProps
}) => {
  return (
    <BoxImgWrapper className={className} {...restProps}>
      <BoxImgInner>
        <Container>
          <Row alignItems="center">
            <Col
              lg={leftCol}
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <Row>
                <BoxImgMedia>
                  {images?.map((image, i) => (
                    <Col
                      key={i}
                      xs={Math.max(Math.floor(12 / images.length), 4)}
                    >
                      <Image
                        src={image.src.localFile || image.src}
                        alt={image.src.alternativeText || title}
                        sizes="(min-width: 768px) 500px, 75vw"
                      />
                    </Col>
                  ))}
                  {name && (
                    <>
                      <Break />
                      <BoxImgText>{name}</BoxImgText>
                    </>
                  )}
                </BoxImgMedia>
              </Row>
            </Col>
            <Col lg={rightCol}>
              <BoxImgContent>
                {title && showTitle && <HeadingWrap>{title}</HeadingWrap>}
                {desc && (
                  <TextWrap
                    dangerouslySetInnerHTML={{
                      __html: desc
                    }}
                  />
                )}
                {children}
              </BoxImgContent>
            </Col>
          </Row>
        </Container>
      </BoxImgInner>
    </BoxImgWrapper>
  )
}

export default BoxImage
